exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../node_modules/css-loader/dist/cjs.js??ref--5-1!../../../../../node_modules/postcss-loader/src/index.js??ref--5-2!../../../../../node_modules/@aofl/webcomponent-css-loader/index.js??ref--5-3!../../../../template/main/css/index.css"), "");
// Module
exports.push([module.id, ".row>div .font-weight-bold{color:var(--blue)}.row>div .font-weight-bold:hover{cursor:pointer}", ""]);
